import React, { useEffect, useState } from "react";
import {
  Cart,
  // check_delivery,
  Compare_add,
  Produts_Add,
  Wish,
} from "../../api/urls";
import { api } from "../../api/api";
import { useParams } from "react-router-dom";
import IMG from "../../Assests/product12.png";
import IMG2 from "../../Assests/image 9.png";
import IMG3 from "../../Assests/image 10.png";
import IMG4 from "../../Assests/frame.png";
// import { Star } from "lucide-react";
import { useDispatch, useSelector } from "react-redux";
import { add, setBuyNowData } from "../../Redux/CartSlice";
import { useNavigate } from "react-router-dom";
import Loading from "../../components/Loading";
import { ProductCard } from "../../components/product_card/ProductCard";
import "./product_details.css";
import Image from "../../components/Image";
import { Box, TextField, Typography } from "@mui/material";
import { Select, MenuItem, Button } from "@mui/material";
// import { IconButton } from "@mui/material";
import { Heart, Loader, MinusIcon, PlusIcon } from "lucide-react";
import useFetch from "../../hooks/useFetch";
import {
  addToWishlist,
  fetchWishlist,
  removeFromWishlist,
} from "../../Redux/WishlistSlice";
import { toast } from "react-toastify";
// import Review from "../order_status/Review";
import ReviewBeanth from "./ReviewBeanth";
import { handleAuthModal, setDefaultDeliveryPincode } from "../../Redux/Auth";
import moment from "moment/moment";
import SizeChart from "./SizeChart";
import NoProductsAvailable from "../../components/NoProductsAvailable";

const ProductDetails = () => {
  // const [productsData, setproductsData] = useState([]);
  const [compare, setCompare] = useState();
  const params = useParams();
  const [selectedSize, setSelectedSize] = useState(null);
  const [selectedColor, setSelectedColor] = useState("");
  const [quantity, setQuantity] = useState(1);
  const { data: products, loading } = useFetch(Produts_Add + params.id + "/");
  const wishlist = useSelector((state) => state.wishlist);
  const accessToken = useSelector((state) => state.auth.accessToken);
  const { defaultPincode } = useSelector((state) => state.auth);
  const [pincode, setPincode] = useState(defaultPincode);
  // const [availabilityMsg, setAvailabilityMsg] = useState("");
  const [isWishlisted, setIsWishlisted] = useState(false);
  const [deliveryMsg, setDeliveryMsg] = useState({});
  const [openSizeChart, setOpenSizeChart] = useState(false);
  const [pinCodeLoading, setPinCodeLoading] = useState(false);
  const [cartLoading, setCartLoading] = useState(false);
  const [wishLoading, setWishLoading] = useState(false);
  const handleCheckAvailability = async () => {
    if (!pincode) {
      setDeliveryMsg("Enter valid pincode ");
      return;
    }

    try {
      const payload = { to_pincode: pincode };
      setPinCodeLoading(true);
      const res = await api.post(`/in/tagon_products/check_delivery/`, payload);
      dispatch(setDefaultDeliveryPincode(payload?.to_pincode));
      if (res.data.is_deliverable) {
        const delivered = moment(res.data.date_of_delivery).format(
          "Do MMMM YYYY",
        );
        setDeliveryMsg({ text: `Delivery available on this pincode by ${delivered}`, status: "success" });
      } else {
        setDeliveryMsg({
          text: "Sorry product not available at the given location",
          status: "error",
        });
      }
    } catch (err) {
      setDeliveryMsg({
        text: "Something went wrong please Try again later",
        status: "error",
      });
    } finally {
      setPinCodeLoading(false);
    }
  };
  useEffect(() => {
    if (defaultPincode && accessToken) {
      handleCheckAvailability();
    }
  }, [defaultPincode]);
  useEffect(() => {
    if (products) {
      const match = wishlist.some((item) => item?.product === products?.id);
      setIsWishlisted(match);
    }
  }, [products, wishlist]);

  const wishID =
    products && wishlist?.find((item) => item.product === products.id)?.id;

  const handleWishlistToggle = async () => {
    if (!products) return;
    if (!accessToken) {
      dispatch(handleAuthModal(true));
      return;
    }
    setWishLoading(true);
    if (isWishlisted) {
      try {
        await api.delete(Wish + `${wishID}/`);
        dispatch(removeFromWishlist(wishID));
        toast.success("Product removed to wishlist");
        setIsWishlisted(false);
      } catch (error) {
        toast.error("Error removing product to wishlist");
      } finally {
        setWishLoading(false);
      }
    } else {
      try {
        const res = await api.post(Wish, { product: products.id });
        dispatch(addToWishlist(res?.data));
        toast.success("Product added to wishlist");
        setIsWishlisted(true);
        // navigate("/wishlist");
        dispatch(fetchWishlist());
        setIsWishlisted(true);
      } catch (error) {
        toast.error("Error adding product to wishlist");
      } finally {
        setWishLoading(false);
      }
    }
  };
  const imagesData = [
    { src: IMG },
    // { src: IMG2 },
    // { src: IMG3 },
    { src: IMG4 },
  ];
  const [currentImage, setCurrentImage] = useState(
    products?.inventory[0]?.images[0]?.img,
  );
  useEffect(() => {
    window.scrollTo(0, 0);
    setCurrentImage(products?.inventory[0]?.images[0]?.img);
  }, [products]);

  const [activeTab, setActiveTab] = useState("Tab1");
  const selectedSizeData = products?.inventory[0].size_and_price?.find(
    (item) => item.size === selectedSize,
  );
  // console.log(products, "i am the select", selectedSize)
  // const data = {
  //   Tab1: products?.description,
  //   Tab2: products?.has_size,
  // };
  const dispatch = useDispatch();
  const navigate = useNavigate();

  // const youLikeImages = products?.you_like_images;

  //   const handleIncrement = () => {
  //   if (quantity < products?.stock) {
  //     setQuantity((prev) => prev + 1);
  //   } else {
  //     toast.error("Only " + products?.stock + " items available in stock!");
  //   }
  // };
  const selectedStock = selectedSizeData?.stock ?? "";
  const handleIncrement = () => {
    if (quantity < selectedStock) {
      setQuantity((prev) => prev + 1);
    }
    // else {
    //   toast.error(`Only ${selectedStock} items available for this size!`);
    // }
    // console.log(selectedStock,"i am the selected stock")
  };

  const handleDecrement = () => setQuantity((prev) => prev - 1);

  const handleSizeChange = (event) => {
    setSelectedSize(event.target.value);
  };

  const colors =
    products?.col_li?.map((col) => ({
      id: col.id,
      hex: col.hex,
      name: col.name,
    })) || [];
  useEffect(() => {
    if (products?.col_li?.length > 0) {
      setSelectedColor(products.col_li[0].id);
    }
  }, [products]);
  const sizes = products?.size_li?.map((size) => ({
    id: size.id,
    label: size.label,
  }));

  useEffect(() => {
    if (sizes?.length > 0) {
      setSelectedSize((prev) => prev || sizes[0].id);
    }
  }, [sizes]);

  const handleAddToCart = async () => {
    // console.log("add to cart is clickedfddd")
    if (!accessToken) {
      dispatch(handleAuthModal(true));
      return;
    }

    if (!pincode) {
      setDeliveryMsg({
        text: "Enter valid pincode",
        status: "error",
      });
      return;
    } else if (deliveryMsg.status === "error") {
      return;
    }
    const hasColor = colors.length > 0;
    const hasSize = sizes.length > 0;

    const colorObj = colors.find((c) => c.id === selectedColor);
    const sizeObj = sizes.find((s) => s.id === selectedSize);

    if ((hasColor && !colorObj) || (hasSize && !sizeObj)) {
      toast.error("Please select all required options.");
      return;
    }

    const payload = {
      product: products.id,
      quantity: quantity,
    };

    if (hasColor && colorObj) {
      payload.hexcolor = colorObj.id;
    }

    if (hasSize && sizeObj) {
      payload.size_label = sizeObj.id;
    }

    // if (hasColor && colorObj) {
    //   payload.hexcolor = colorObj.name;
    // }

    // if (hasSize && sizeObj) {
    //   payload.size_label = sizeObj.label;
    // }

    try {
      // const accessToken = localStorage.getItem("auth_token");
      setCartLoading(true);
      const cartResponse = await api.get(Cart);

      const cartItems = cartResponse.data;
      const existingItem = cartItems.find(
        (item) => item.product === payload.product,
        // item.hexcolor === payload.hexcolor &&
        // item.size_label === payload.size_label
      );

      if (existingItem) {
        const patchPayload = {
          quantity: existingItem.quantity + payload.quantity,
        };

        await api.patch(`${Cart}${existingItem.id}/`, patchPayload);

        navigate("/shop_cart");
      } else {
        // console.log("Adding to cart");
        const response = await api.post(
          Cart,
          payload,
          // headers: {
          //   Authorization: `Bearer ${accessToken}`,
          // },}
        );
        dispatch(add(response.data));
        navigate("/shop_cart");
      }
    } catch (error) {
      console.error(" Cart error:", error.response?.data || error.message);
      toast.error(error.response?.data?.message || "Error adding to cart.");
    } finally {
      setCartLoading(false);
    }
  };
  const handleBuyNow = async () => {
    if (!accessToken) {
      dispatch(handleAuthModal(true));
      return;
    }

    if (!pincode) {
      setDeliveryMsg({
        text: "Enter valid pincode",
        status: "error",
      });
      return;
    } else if (deliveryMsg.status === "error") {
      return;
    }
    const hasColor = colors.length > 0;
    const hasSize = sizes.length > 0;

    const colorObj = colors.find((c) => c.id === selectedColor);
    const sizeObj = sizes.find((s) => s.id === selectedSize);

    if ((hasColor && !colorObj) || (hasSize && !sizeObj)) {
      toast.error("Please select all required options.");
      return;
    }

    navigate("/buy_now");
    dispatch(
      setBuyNowData({
        ...products,
        id: products.id,
        selected_quantity: quantity,
        selected_size: selectedSize,
        selected_size_name: sizeObj && sizeObj.label,
        selected_color: selectedColor,
        sell_price: sellPrice,
        product_price: productPrice,
        you_save: discountPrice,
        packing_and_forwarding_charges: packing_and_forwarding_charges,
        shipping_charges: shipping_charges,

        discount_price: discount_price,
      }),
    );
  };

  const { data: newproduct } = useFetch(
    products && `${Produts_Add}?third_category=${products?.third_cat_id}`,
  );
  // console.log(newproduct, "newproduct");
  // useEffect(() => {
  //   if (newproduct) {
  //     const productsinner = newproduct;
  //     setproductsData(productsinner);
  //   }
  // }, [newproduct]);

  useEffect(() => {
    if (newproduct?.count > 0 && params.id) {
      const filteredIds = newproduct.results
        .filter((item) => item.id !== parseInt(params.id)) // exclude matching ID
        .slice(0, 5) // take up to 5
        .map((item) => item.id);

      const ids = [params.id, ...filteredIds];
      //  console.log("compare ids:", ids);

      const query = `${Compare_add}?products=${ids.join(",")}`;
      // console.log("compare API query:", query);

      api
        .get(query)
        .then((response) => {
          setCompare(response.data);
        })
        .catch((error) => {
          console.error("API Error:", error);
        });
    }
  }, [newproduct, params.id]);
  // console.log(newproduct,"i ama product")


  const matchedItem = products?.inventory?.find(
    (item) => item?.size_and_price?.[0]?.size === selectedSize,
  );
  // Start with an empty array
  const tabs = [];

  // Add Description if it exists
  if (products?.description && products?.description.trim() !== "") {
    tabs.push({
      label: "Description",
      key: "Tab1",
      content: products?.description,
    });
  }

  // Add other tabs dynamically from API info array
  products?.information?.forEach((info, index) => {
    const hasData = info.all_parameters.some(
      (param) =>
        (param.values && param.values.length > 0) ||
        (param.product_property_type &&
          param.product_property_type.trim() !== ""),
    );
    if (hasData) {
      tabs.push({
        label: info.product_info, // General / Additional / Technical
        key: `Tab${tabs.length + 1}`, // generate next Tab key
        content: info.all_parameters, // store parameters for rendering
      });
    }
  });

  const youMayLikeData = products?.you_like_images?.filter(
    (f) => f.id !== Number(params.id),
  );

  // pick the active size/price object once
  const singleInv = products?.inventory?.[0]?.size_and_price?.[0];
  const active =
    products?.inventory?.length === 1
      ? singleInv
      : (matchedItem?.size_and_price?.[0] ?? null);

  // then just read from it
  const productPrice = active?.product_price;
  const sellPrice = active?.sell_price;
  const discountPrice = active?.you_save;
  const stock = active?.stock;
  const discount_price = active?.discount_price;
  const shipping_charges = active?.shipping_charges;
  const cod = active?.cod;
  const packing_and_forwarding_charges = active?.packing_and_forwarding_charges;
  const savePercent = active?.discout_percent;
  // console.log(shipping_charges, "i am shipp")

  const [openAccordion, setOpenAccordion] = useState(null);

  if (loading) {
    return <Loading />;
  }

  if (!loading && !products) {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "90vh",
        }}
      >
        <NoProductsAvailable />
      </div>
    );
  }

  return (
    <div className="w-[90%] mx-auto mt-5">
      <div className="grid md:grid-cols-2 mb-5 gap-4">
        <div
          className="xl:flex justify-end"
          // className="product-image-container"
        >
          <div className="flex gap-5 xl:flex-row flex-col-reverse bg-white">
            <div className="flex xl:flex-col flex-row gap-2 flex-wrap justify-center">
              {/* COUNT FOR NUMBER OF IMAGES */}
              {Array(products?.inventory[0]?.images.length)
                .fill()
                .map((_, index) => (
                  <div
                    key={index}
                    // style={{
                    //   width: "100px",
                    //   height: "120px",
                    //   border: "1px solid #ccc",
                    //   backgroundColor: "#f4f4f4",
                    //   display: "flex",
                    //   boxSizing: "border-box",
                    //   borderRadius: "10px",
                    //   cursor: "pointer",
                    // }}
                    className="w-[100px] h-[120px] cursor-pointer flex rounded-xl border"
                    onClick={() =>
                      setCurrentImage(
                        products?.inventory[0]?.images[index]?.img,
                      )
                    }
                  >
                    <Image
                      src={products?.inventory[0]?.images[index]?.img}
                      alt={`Thumbnail ${index + 1}`}
                      style={{
                        width: "100%",
                        height: "100%",
                        objectFit: "cover",
                        // maxWidth:"500px"
                      }}
                      className="shrink-0 rounded-xl"
                    />
                  </div>
                ))}
            </div>

            <Image
              src={currentImage}
              alt="Product"
              // style={{ objectFit: "contain" }}
              className="rounded-2xl object-cover max-h-[80vh] md:max-w-[30vw] border"
            />

            <button
              onClick={handleWishlistToggle}
              disabled={wishLoading}
              className="
      absolute right-2 top-2 z-10 grid place-content-center
      h-9 w-9 rounded-full bg-white shadow
      transition hover:bg-gray-100
    "
            >
              {wishLoading ? (
                <Loader className="animate-spin" />
              ) : (
                <Heart
                  size={20}
                  className={
                    isWishlisted ? "text-red-500 fill-red-500" : "text-gray-500"
                  }
                />
              )}
            </button>
          </div>
        </div>

        <div className="md:mx-5 mx-auto flex flex-col md:items-start items-center bg-white w-full">
          {/* Product Title */}
          <p
            style={{
              fontSize: "clamp(24px, 2.5vw, 30px)",
              fontWeight: 500,
              lineHeight: "1.2",
              color: "#000",
              marginBottom: "16px",
            }}
          >
            {products.title}{" "}
            {products?.unit2lot > 1 && `(Pack of ${products?.unit2lot})`}{" "}
          </p>

          <p
            style={{
              fontSize: "16px",
              marginBottom: "20px",
            }}
          >
            Availability:{" "}
            <span
              style={{
                color: stock > 0 ? "green" : "red",
                fontWeight: 600,
              }}
            >
              {stock > 0 ? "In-Stock" : "Out of Stock"}
            </span>
          </p>

          {/* <p
  style={{
    fontSize: "16px",
    marginBottom: "20px",
   
  }}
>
  Size Chart:View Chart
</p> */}
          <p style={{ fontSize: "16px", marginBottom: "8px" }}>
            Size Chart:{" "}
            <span
              onClick={() => setOpenSizeChart(true)}
              style={{
                color: "#007aff",
                cursor: "pointer",
                textDecoration: "underline",
                fontWeight: 500,
              }}
            >
              View Chart
            </span>
          </p>

          <p
            style={{
              fontSize: "16px",
              // marginBottom: "20px",
            }}
          >
            Sold By:{" "}
            <span style={{ fontWeight: 600 }}>
              {products?.seller_name || "—"}
            </span>
          </p>
          {/* Updated Pricing Section  */}
      {   stock > 0 && <div
            style={{ marginTop: "30px" }}
            className="flex flex-col md:items-start items-center gap-2"
          >
            <div className="flex gap-3 mb-4">
              <p className="text-gray-500 line-through">₹ {productPrice}/-</p>
              <p className="text-green-800 text-sm bg-green-100 py-1 px-4 rounded-full">
                {savePercent}% OFF
              </p>
            </div>

            <p
              style={{
                fontSize: "clamp(24px, 2.5vw, 30px)",
                fontWeight: 500,
                lineHeight: "1.2",
                color: "#000",
              }}
            >
              ₹{discount_price || "N/A"}
            </p>
          </div>}
          {/* Size & Quantity */}
          {stock > 0 && (
            <div className="flex mb-10 mt-10 gap-6">
              {/* Quantity */}
              <div>
                <p
                  className="mb-2"
                  // sx={{
                  //   fontSize: "20px",
                  //   fontWeight: 500,
                  //   fontFamily: "Inter",
                  // }}
                >
                  Qty
                </p>
                <Box
                  sx={{ display: "flex", alignItems: "center", gap: "6px" }}
                  flexShrink={0}
                >
                  <button
                    disabled={quantity === 1}
                    onClick={handleDecrement}
                    className="border p-2 rounded-md h-10 w-10 flex items-center justify-center disabled:bg-gray-200 disabled:text-black bg-black text-white"

                    // sx={{
                    //   minHeight: "25px",
                    //   backgroundColor: "#000",
                    //   color: "#fff",
                    //   borderRadius: "4px",
                    //   padding: "6px 12px",
                    //   minWidth: "auto",
                    //   "&:hover": {
                    //     backgroundColor: "#333",
                    //   },
                    // }}
                  >
                    <MinusIcon size={18} />
                  </button>

                  <div className="border p-2 rounded-md h-10 w-10 flex items-center justify-center">
                    {quantity.toString()}
                  </div>

                  <button
                    disabled={quantity === selectedStock}
                    onClick={handleIncrement}
                    className={`border p-2 rounded-md h-10 w-10 flex items-center justify-center disabled:bg-gray-200 disabled:text-black bg-black text-white`}
                  >
                    <PlusIcon size={18} />
                  </button>
                </Box>
              </div>
              {/* Size */}
              {products?.has_size && (
                <Box
                  // sx={{ display: "flex", alignItems: "center", gap: "8px" }}
                  flexShrink={0}
                >
                  <p
                    className="mb-2"
                    // sx={{
                    //   fontSize: "20px",
                    //   fontWeight: 500,
                    //   fontFamily: "Inter",
                    // }}
                  >
                    Size
                  </p>

                  <Select
                    displayEmpty
                    value={selectedSize || ""}
                    onChange={handleSizeChange}
                    sx={{
                      minWidth: "100px",
                      minHeight: "42px",
                      fontSize: "16px",
                      backgroundColor: "#fff",
                      borderRadius: "6px",
                      "& .MuiSelect-select": {
                        padding: "4px 10px",
                        fontSize: "13px",
                      },
                    }}
                  >
                    {sizes.map((size) => (
                      <MenuItem
                        key={size.id}
                        value={size.id}
                        sx={{ fontSize: "13px" }}
                      >
                        {size.label}
                      </MenuItem>
                    ))}
                  </Select>
                </Box>
              )}
            </div>
          )}

          {products?.has_color && (
            <div style={{ marginBottom: "10px" }}>
              <p
                style={{
                  fontWeight: "600",
                  fontSize: "16px",
                  marginBottom: "8px",
                }}
              >
                Colors:
              </p>

              <div style={{ display: "flex", gap: "8px", flexWrap: "wrap" }}>
                {[
                  ...new Map(
                    products.inventory.map((item) => [item.col, item]),
                  ).values(),
                ].map((d, i) => (
                  <div
                    key={i}
                    onClick={() => setSelectedColor(d.col)}
                    style={{
                      height: "50px",
                      width: "50px",
                      borderRadius: "50%",
                      overflow: "hidden",
                      cursor: "pointer",
                      border:
                        selectedColor === d.col
                          ? "2px solid #000"
                          : "2px solid #ccc",
                    }}
                  >
                    <img
                      src={d?.images?.[0]?.img}
                      alt="color"
                      style={{
                        objectFit: "cover",
                        height: "50px",
                        width: "50px",
                      }}
                    />
                  </div>
                ))}
              </div>
            </div>
          )}

          {/* Action Buttons */}
          {stock > 0 && (
            <div
              style={{
                display: "flex",
                gap: "12px",
                margin: "12px 0",
                flexWrap: "wrap",
              }}
            >
              <Button
                onClick={handleAddToCart}
                disabled={cartLoading}
                variant="outlined"
                sx={{
                  borderColor: "#000",
                  color: "#000",
                  textTransform: "none",
                  borderRadius: "4px",
                  fontSize: "13px",
                  px: 4,
                  py: 1,
                  "&:hover": { backgroundColor: "#e7e7e7ff" },
                }}
              >
                Add to cart
              </Button>

              <Button
                variant="contained"
                onClick={handleBuyNow}
                sx={{
                  backgroundColor: "#000",
                  textTransform: "none",
                  borderRadius: "6px",
                  fontSize: "13px",
                  px: 4,
                  py: 1,
                  "&:hover": { backgroundColor: "#333" },
                }}
              >
                Proceed to buy
              </Button>
            </div>
          )}

          {/* Service Images */}

          {stock > 0 && (
            <div
              className="thumbnail-container"
              style={{
                display: "flex",
                gap: "10px",
                marginBottom: "30px",
                marginTop: "30px",
                flexWrap: "wrap", // default for small screens
                justifyContent: "center",
              }}
            >
              {imagesData.map((item, idx) => (
                <div key={idx} className="flex flex-col items-center">
                  <img
                    src={item.src}
                    alt={`Service ${idx + 1}`}
                    style={{
                      width: "50px",
                      height: "50px",
                      objectFit: "contain",
                      borderRadius: "5px",
                      flexShrink: 0,
                    }}
                  />

                  {idx === 0 && products.return_by && (
                    <p
                      style={{
                        marginTop: "5px",
                        fontSize: "12px",
                        color: "#555",
                      }}
                    >
                      Return By {products.return_by}
                    </p>
                  )}
                  {idx === 1 && products.return_by && (
                    <p
                      style={{
                        marginTop: "5px",
                        fontSize: "12px",
                        color: "#555",
                      }}
                    >
                      Replace By {products.return_by}
                    </p>
                  )}
                </div>
              ))}

              {/* Free Delivery image & text */}
              {shipping_charges === 0 && (
                <div style={{ textAlign: "center", marginRight: "10px" }}>
                  <img
                    src={IMG2}
                    alt="Free Delivery"
                    style={{
                      width: "50px",
                      height: "50px",
                      objectFit: "contain",
                      borderRadius: "5px",
                      flexShrink: 0,
                    }}
                  />
                  <p
                    style={{
                      marginTop: "5px",
                      fontSize: "12px",
                      color: "green",
                    }}
                  >
                    Free Delivery
                  </p>
                </div>
              )}
              {cod && (
                <div style={{ textAlign: "center", marginRight: "10px" }}>
                  <img
                    src={IMG3}
                    alt="Free Delivery"
                    style={{
                      width: "50px",
                      height: "50px",
                      objectFit: "contain",
                      borderRadius: "5px",
                      flexShrink: 0,
                    }}
                  />
                  <p
                    style={{
                      marginTop: "5px",
                      fontSize: "12px",
                      color: "green",
                    }}
                  >
                    Pay On Delivery
                  </p>
                </div>
              )}
            </div>
          )}
          {/* {cod && (
  <p style={{ marginTop: "5px", fontSize: "12px", color: "green", textAlign: "center" }}>
    Pay on Delivery
  </p>
)} */}

          {stock > 0 && accessToken && (
            <div
              // style={{
              //   display: "flex",
              //   alignItems: "center",
              //   gap: "8px",
              //   marginTop: "16px",
              // }}
              className="flex items-center gap-2 mt-4 md:justify-start justify-center"
            >
              <TextField
                placeholder="Enter Pincode"
                value={pincode}
                onChange={(e) => setPincode(e.target.value)}
                size="small"
                sx={{
                  width: "150px",
                  "& .MuiOutlinedInput-root": {
                    borderRadius: "6px",
                  },
                }}
              />

              <Button
                variant="contained"
                disabled={pinCodeLoading}
                sx={{
                  backgroundColor: "#000",
                  textTransform: "none",
                  borderRadius: "6px",
                  fontSize: "13px",
                  px: 2,
                  "&:hover": { backgroundColor: "#333" },
                }}
                onClick={handleCheckAvailability}
              >
                {pinCodeLoading ? "Checking..." : "Check"}
              </Button>
            </div>
          )}

          {/*  Show Delivery Message */}
          {stock > 0 && deliveryMsg?.text && (
            <p
              style={{
                fontSize: "14px",
                marginTop: "8px",
                fontWeight: 500,
                color: deliveryMsg?.text.includes("Delivery available on this pincode by")
                  ? "green"
                  : "red", //  red for not deliverable
              }}
            >
              {deliveryMsg?.text}
            </p>
          )}

          {/* Tabs Section */}
          {/* <div style={{ marginTop: "20px" }}>
            <div
              style={{
                display: "flex",
                gap: "15px",
                marginBottom: "10px",
                flexWrap: "wrap",
              }}
            >
              <div
                style={{
                  display: "flex",
                  gap: "15px",
                  marginBottom: "10px",
                  flexWrap: "wrap",
                }}
              >
                {tabs.map((tab) => (
                  <button
                    key={tab.key}
                    onClick={() => setActiveTab(tab.key)}
                    style={{
                      cursor: "pointer",
                      border: "none",
                      background: "none",
                      padding: 0,
                      margin: 0,
                      fontWeight: 500,
                      fontSize: "16px",
                      lineHeight: "100%",
                      letterSpacing: "0%",
                      color: activeTab === tab.key ? "#000000" : "#00000080",
                      textDecoration:
                        activeTab === tab.key ? "underline" : "none",
                      fontFamily: "Inter, sans-serif",
                      whiteSpace: "nowrap",
                    }}
                  >
                    {tab.label}
                  </button>
                ))}
              </div>
            </div>
            <div
              style={{
                color: "#000",
                fontSize: "14px",
                lineHeight: "24px",
                wordWrap: "break-word",
                margin: 0,
              }}
            >
              {tabs.map((tab) => {
                if (activeTab !== tab.key) return null;

                // If content is a string (Description)
                if (typeof tab.content === "string") {
                  return <p key={tab.key}>{tab.content}</p>;
                }

                // If content is array (General / Additional / Technical)
                return tab.content.map((param, idx) => (
                  <div key={idx}>
                    {param.values && param.values.length > 0 ? (
                      <>
                        <strong>{param.product_property_type}:</strong>{" "}
                        {param.values.map((v) => v.name).join(", ")}
                      </>
                    ) : (
                      <strong>{param.product_property_type}</strong>
                    )}
                  </div>
                ));
              })}
            </div>
          </div> */}

          {/* TABS (md+) */}
          <div className="hidden xl:block mt-5">
            <div className="flex flex-wrap gap-4 mb-3">
              {tabs.map((tab) => (
                <button
                  key={tab.key}
                  onClick={() => setActiveTab(tab.key)}
                  className={`
          whitespace-nowrap
          text-base
          font-medium
          font-inter
          ${activeTab === tab.key ? "text-black underline" : "text-black/50"}
        `}
                >
                  {tab.label}
                </button>
              ))}
            </div>

            <div className="text-sm leading-6 text-black">
              {tabs.map((tab) => {
                if (activeTab !== tab.key) return null;

                if (typeof tab.content === "string") {
                  return <p key={tab.key}>{tab.content}</p>;
                }

                return tab.content.map((param, idx) => (
                  <div key={idx}>
                    {param.values?.length ? (
                      <>
                        <strong>{param.product_property_type}:</strong>{" "}
                        {param.values.map((v) => v.name).join(", ")}
                      </>
                    ) : (
                      <strong>{param.product_property_type}</strong>
                    )}
                  </div>
                ));
              })}
            </div>
          </div>

          {/* ACCORDION (sm) */}
          <div className="xl:hidden mt-5 space-y-3 w-full">
            {tabs.map((tab) => {
              const isOpen = openAccordion === tab.key;

              return (
                <div key={tab.key} className="border-b border-black/10 pb-2">
                  <button
                    onClick={() => setOpenAccordion(isOpen ? null : tab.key)}
                    className="w-full flex justify-between items-center text-left text-base font-medium text-black"
                  >
                    {tab.label}
                    <span className="text-lg">{isOpen ? "−" : "+"}</span>
                  </button>

                  {isOpen && (
                    <div className="mt-2 text-sm leading-6 text-black">
                      {typeof tab.content === "string" ? (
                        <p>{tab.content}</p>
                      ) : (
                        tab.content.map((param, idx) => (
                          <div key={idx}>
                            {param.values?.length ? (
                              <>
                                <strong>{param.product_property_type}:</strong>{" "}
                                {param.values.map((v) => v.name).join(", ")}
                              </>
                            ) : (
                              <strong>{param.product_property_type}</strong>
                            )}
                          </div>
                        ))
                      )}
                    </div>
                  )}
                </div>
              );
            })}
          </div>
        </div>
      </div>

      {/* secons section */}

      <hr
        style={{
          border: "none",
          height: "2px",
          background:
            "repeating-linear-gradient(to right, red, orange 20%, yellow 40%, green 60%, blue 80%, indigo)",
        }}
        className="md:block hidden"
      />

      {youMayLikeData?.length > 0 && (
        <Box
          sx={{
            width: "100%",
            // maxWidth: "1445px",
            margin: "0 auto",
            padding: "25px",
          }}
        >
          <Typography
            variant="h5"
            sx={{
              marginBottom: "30px",
              marginTop: "30px",
              fontWeight: 600,
              fontSize: "1.5rem",
              fontFamily: "Inter",
              textAlign: "left",
              // marginLeft: "16px",
            }}
          >
            You may also like
          </Typography>

          <Box
            sx={{
              display: "grid",
              gridTemplateColumns: {
                xs: "repeat(2, 1fr)",
                sm: "repeat(3, 1fr)",
                md: "repeat(4, 1fr)",
                lg: "repeat(6, 1fr)",
              },
              gap: "10px",
            }}
          >
            {youMayLikeData?.map((item) => (
              <Box
                key={item.id}
                sx={{
                  // height: "380px",
                  borderRadius: "8px",
                  overflow: "hidden",
                  backgroundColor: "#fff",
                  transition: "transform 0.2s ease-in-out",
                }}
              >
                <ProductCard
                  product={item}
                  isYouMayLike={true}
                  image={item.images}
                  data={"Recommended"}
                />
              </Box>
            ))}
          </Box>
        </Box>
      )}

      {/* {compare?.[0]?.prod.length > 1 && (
        <div
          className="compare-products-wrapper"
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            padding: "40px 16px",
            overflowX: "auto",
          }}
        >
          <div
            className="compare-products"
            style={{ width: "100%", maxWidth: "1400px" }}
          >
            <h3 className="text-lg mb-2">Compare with similar products</h3>

            <div
              style={{
                overflowX: "auto", // allows horizontal scroll
                width: "100%",
                WebkitOverflowScrolling: "touch", // smooth on iOS
              }}
            >
              <table
                style={{
                  backgroundColor: "#F8F8F8",
                  border: "1px solid #0000001A",
                  borderCollapse: "collapse",
                  minWidth: "750px", // makes sure table doesn't shrink
                }}
              >
                <tbody>
                  <tr>
                    <td style={tableCellStyle}>
                      <h3
                        style={{
                          fontFamily: "Inter",
                          fontSize: "25px",
                          fontWeight: 600,
                          lineHeight: "30.26px",
                          color: "#FF775F",
                          margin: 0,
                        }}
                      >
                        0{compare?.[0]?.prod.length}
                      </h3>
                      <h5
                        style={{
                          fontFamily: "Inter",
                          fontSize: "12px",
                          fontWeight: 400,
                          lineHeight: "14.52px",
                          color: "#000000",
                          margin: 0,
                        }}
                      >
                        Products to compare
                      </h5>
                    </td>
                    {compare?.[0]?.prod?.map((item, index) => (
                      <td key={index} style={tableCellStyle}>
                        <Image
                          src={item?.img}
                          alt={`Product ${index}`}
                          style={{
                            width: "145px",
                            height: "200px",
                            objectFit: "cover",
                            borderRadius: "5px",
                          }}
                        />
                      </td>
                    ))}
                  </tr>
                  {compare?.[0]?.property?.flatMap((group) =>
                    group.prop_list.map((property, propertyIndex) => (
                      <tr key={property.property_name + propertyIndex}>
                        <td style={tableCellStyle}>{property.property_name}</td>
                        {[...Array(compare[0]?.prod?.length)].map(
                          (_, prodIndex) => (
                            <td key={prodIndex} style={tableCellStyle}>
                              {property.prop_val?.[prodIndex]?.name || "N/A"}
                            </td>
                          ),
                        )}
                      </tr>
                    )),
                  )}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      )} */}
      {/* COMPARE */}
      {compare?.[0]?.prod?.length > 1 && (
        <div className="flex justify-center md:py-12 py-4 overflow-x-auto">
          <div className="w-full max-w-7xl">
            <h3 className="text-xl font-semibold mb-6">
              Compare with similar products
            </h3>

            <div className="overflow-x-auto rounded-2xl border border-gray-200 bg-gray-50">
              <table className="min-w-[750px] w-full border-collapse text-sm">
                <tbody>
                  {/* Image Row */}
                  <tr className="bg-white">
                    {/* Product Count */}
                    <td className="p-6 border border-gray-200 text-center align-middle sticky left-0 bg-white z-10">
                      <h3 className="text-3xl font-semibold text-orange-500 leading-tight">
                        0{compare?.[0]?.prod.length}
                      </h3>
                      <p className="text-xs text-gray-600">
                        Products to compare
                      </p>
                    </td>

                    {compare?.[0]?.prod?.map((item, index) => (
                      <td
                        key={index}
                        className="p-6 border border-gray-200 text-center align-middle"
                      >
                        <img
                          src={item?.img}
                          alt={`Product ${index}`}
                          className="w-36 h-52 object-cover rounded-lg mx-auto"
                        />
                      </td>
                    ))}
                  </tr>

                  {/* Properties */}
                  {compare?.[0]?.property?.flatMap((group) =>
                    group.prop_list.map((property, propertyIndex) => (
                      <tr
                        key={property.property_name + propertyIndex}
                        className="even:bg-white odd:bg-gray-50"
                      >
                        {/* Property Name */}
                        <td className="border border-gray-200 font-medium text-gray-700 sticky left-0 bg-inherit z-10">
                          {property.property_name}
                        </td>

                        {/* Values */}
                        {[...Array(compare[0]?.prod?.length)].map(
                          (_, prodIndex) => (
                            <td
                              key={prodIndex}
                              className="p-4 border border-gray-200 text-center text-gray-600"
                            >
                              {property.prop_val?.[prodIndex]?.name || "N/A"}
                            </td>
                          ),
                        )}
                      </tr>
                    )),
                  )}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      )}

      {products?.product_content_reviews?.length > 0 && (
        <div>
          <ReviewBeanth product={products} />
        </div>
      )}
      <SizeChart
        open={openSizeChart}
        onClose={() => setOpenSizeChart(false)}
        chartData={products?.chart_data}
        sizeChartImage={products?.size_chart}
      />
    </div>
  );
};

export default ProductDetails;
